import { Form } from "@unform/web";
import { useState } from "react";

import { HTTPErrorCallback } from "Helpers/Error";
import { documentExtensions, imageExtensions } from "Helpers/File";

import UseFile from "Hooks/UseFile";
import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import FileUploader from "Components/Admin/FileUploader";
import Button from "Components/Global/Buttons";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const FileUpload = ({
  projectId,
  setOpenModal,
  documentId,
  setDocumentId,
  reload,
  documentName,
  setDocumentName,
}) => {
  const theme = useTheme();

  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading();
  const { uploadFile } = UseFile();

  const [files, setFiles] = useState([]);

  const submit = async (data) => {
    setLoading(true);

    try {
      const files_to_send = [];

      for (const file of files) {
        const image_location = file.file_src
          ? file.file_src
          : await uploadFile(file?.file);

        files_to_send.push({
          id: file?.id,
          name: file.name,
          file_src: image_location,
        });
      }

      const is_approval = documentName.includes(
        "Documento de comprovação de aprovação na lei de incentivo",
      );

      await api.post("/projects/files/upload", {
        ...data,
        project_id: projectId,
        document_id: documentId,
        files: files_to_send,
        document_name: is_approval ? documentName : null,
      });

      setLoading(false);

      showNotification("success", "Sucesso!", "Arquivos enviados com sucesso!");

      setOpenModal(null);
      setDocumentId(null);
      setDocumentName(null);

      reload(projectId);
    } catch (error) {
      setLoading(false);
      return HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      <S.Modal>
        <Form onSubmit={submit}>
          <S.Section>
            <span>Enviar Arquivos</span>
            <hr />
          </S.Section>

          <FileUploader
            allowMultiple={false}
            label="Arquivos"
            loading={loading}
            allowedExtensions={[...imageExtensions, ...documentExtensions]}
            setFiles={(file) =>
              setFiles((prev) => [
                ...prev,
                {
                  file: file[0],
                  name: file[0].name,
                },
              ])
            }
          />

          {files.map((file) => (
            <S.File key={file.name}>
              <S.FileInfos>
                {file.file_src ? (
                  <a href={file.file_src} rel="noreferrer" target="_blank">
                    {file.name}
                  </a>
                ) : (
                  <h2>{file.name}</h2>
                )}

                <GetIcon
                  name="X"
                  color={theme.colors.neutral.white}
                  onClick={() =>
                    setFiles((prev) => prev.filter((f) => f.name !== file.name))
                  }
                />
              </S.FileInfos>
            </S.File>
          ))}

          <S.Buttons>
            <Button
              type="button"
              outline
              text="Fechar"
              disabled={loading}
              onClick={() => {
                setOpenModal(null);
                setDocumentId(null);
                setDocumentName(null);
              }}
            />

            <Button type="submit" text="Enviar" disabled={loading} />
          </S.Buttons>
        </Form>
      </S.Modal>
    </S.Wrapper>
  );
};

export default FileUpload;
